import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Polygon,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Polygon, { points: "19 20 9 12 19 4 19 20", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "5", x2: "5", y1: "19", y2: "5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "SkipBack";
const SkipBack = memo(themed(Icon));
export {
  SkipBack
};
//# sourceMappingURL=skip-back.js.map
